<script>
import ScoreBar from '@/components/common/ScoreBar.vue';

export default {
  name: 'ProSurveyTable',
  components: { ScoreBar },
  props: {
    surveys: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    error: { type: String, default: null },
    hasFilters: { type: Boolean, default: false },
  },
  emits: ['edit', 'delete', 'clear-filters'],
  methods: {
    formatDate(value) {
      if (!value) {
        return '-';
      }

      const d = new Date(value);
      const pad = (n) => String(n).padStart(2, '0');

      return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },

    statusLabel(status) {
      return status === 'SUBMITTED' ? 'Soumise' : 'Brouillon';
    },

    statusClass(status) {
      return status === 'SUBMITTED'
        ? 'list-badge--submitted'
        : 'list-badge--draft';
    },

    actionLabel(status) {
      // A draft is resumed where it was left; a submitted one is just opened.
      return status === 'DRAFT' ? 'Continuer' : 'Ouvrir';
    },
  },
};
</script>

<template>
  <div>
    <p v-if="error" class="list-card__error" role="alert">{{ error }}</p>

    <p v-if="loading" class="list-card__state">Chargement des enquêtes…</p>

    <div v-else-if="surveys.length" class="list-card__table-wrap">
      <table class="list-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Exercice</th>
            <th>Raison sociale</th>
            <th>Gouvernorat</th>
            <th>Activité principale</th>
            <th>Complétude</th>
            <th>Statut</th>
            <th class="list-table__actions-head">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="survey in surveys" :key="survey.id">
            <td data-label="Date">{{ formatDate(survey.createdAt) }}</td>
            <td data-label="Exercice">{{ survey.referenceYear || '-' }}</td>
            <td
              class="list-table__name"
              data-label="Raison sociale"
              @click="$emit('edit', survey.id)"
            >
              {{ survey.companyLegalName || '-' }}
            </td>
            <td data-label="Gouvernorat">
              {{ survey.companyGovernorate || '-' }}
            </td>
            <td data-label="Activité principale">
              {{ survey.companyMainActivity || '-' }}
            </td>
            <td data-label="Complétude">
              <ScoreBar
                :score="survey.completenessScore"
                :answered="survey.completenessAnswered"
                :total="survey.completenessTotal"
              />
            </td>
            <td data-label="Statut">
              <span class="list-badge" :class="statusClass(survey.status)">
                {{ statusLabel(survey.status) }}
              </span>
            </td>
            <td>
              <div class="list-table__actions">
                <button
                  type="button"
                  class="row-action"
                  :title="actionLabel(survey.status)"
                  @click="$emit('edit', survey.id)"
                >
                  <i class="ri-pencil-line"></i>
                  {{ actionLabel(survey.status) }}
                </button>
                <!-- Only drafts can be removed. -->
                <button
                  v-if="survey.status === 'DRAFT'"
                  type="button"
                  class="row-action row-action--danger"
                  title="Supprimer le brouillon"
                  @click="$emit('delete', survey)"
                >
                  <i class="ri-delete-bin-line"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else class="list-card__empty">
      <p class="list-card__empty-text">
        {{
          hasFilters
            ? 'Aucune enquête ne correspond à ces filtres.'
            : "Vous n'avez pas encore créé d'enquête."
        }}
      </p>
      <button
        v-if="hasFilters"
        type="button"
        class="list-card__empty-action"
        @click="$emit('clear-filters')"
      >
        Effacer les filtres
      </button>
    </div>
  </div>
</template>
